import React, {useState, useEffect} from 'react'
import {MDBBadge, MDBCard} from "mdbreact";
import classes from './SocialComment.module.css'
import {timeObjToString, timeStampToString} from "../../../../Utils/converter";

const SocialComment = (props) => {
    const [isDeleting, setIsDeleting] = useState(false)
    return (
        <MDBCard className={classes.SocialComment}>
            {
                props.isAdmin && props.isEditMode &&
                <button className={classes.DeleteImageBtn}
                        disabled={isDeleting}
                        onClick={() => {
                            setIsDeleting(true)
                            props.removeComment(props.data.id)
                        }}>
                    X
                </button>
            }

            <div className={classes.Top}>
                <div className={classes.SourceName}
                     onClick={(e) => {
                         window.open(
                             props.data.sourceUrl,
                             '_blank' // <- This is what makes it open in a new window.
                         );
                     }}
                >{props.data.sourceUserName} @ {props.data.sourceName}  </div>
                <div className={classes.SourceDate}>
                    {
                        typeof props.data.sourceDate.seconds !== "undefined" ?
                            timeStampToString(props.data.sourceDate.seconds)
                            :
                            timeObjToString(props.data.sourceDate)
                    }
                </div>
            </div>
            <div className={classes.SourceContent}>
                {props.data.content}
            </div>

        </MDBCard>
    )
}
export default SocialComment